import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { HsnSacCode, HsnSacCodeCreate, HsnSacCodeFilter } from '../data/hsnSacCode';

export function createHsnSacCodeService(client: AxiosInstance) {
  return createCrudService<HsnSacCode, HsnSacCodeCreate, HsnSacCodeFilter>(
    client,
    '/master-data/HsnSacCode',
    'id',
  );
}

export type HsnSacCodeService = CrudService<HsnSacCode, HsnSacCodeCreate, HsnSacCodeFilter>;
